import { useRef, type TextareaHTMLAttributes } from 'react';

import { useAutoGrow } from '@/hooks/useAutoGrow';
import { inputClass } from '@/lib/formStyles';

interface AutoTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
}

// Canonical textarea that grows with its content (no inner scrollbar).
export function AutoTextarea({ value, className, rows = 2, ...rest }: AutoTextareaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useAutoGrow(ref, value);

  return (
    <textarea
      ref={ref}
      value={value}
      rows={rows}
      className={`${className ?? inputClass} resize-none overflow-hidden`}
      {...rest}
    />
  );
}
